<template>
  <div>
    <div
      class="effect-menu-toggle horizontal"
      id="effect-toggler"
      @click="handleClickIcon"
      @mouseover="handleHoverEffectMenuToggleIcon"
      @mouseleave="setEffectMenuVisibility(false)"
    >
      <img
        src="@/assets/images/icon/confetti-white.svg"
        class="text-base-70 effect-icon"
        :class="{
          'white-icon': !isTextColourLight,
        }"
      >
    </div>
    <div
      v-if="showEffectMenu"
      class="effect-menu"
      :class="{
        'has-chat': isLiveChatVisible,
        'no-chat': !isLiveChatVisible,
        'white': isTextColourWhite,
        'black': !isTextColourWhite,
        'ppt-effect': isEnableAddinPowerpoint
      }"
      @mouseenter="setEffectMenuVisibility(true)"
      @mouseleave="() => {
        showEffectMenu = false
      }"
      @focusout="handleFocusOutEffectMenu"
      v-click-outside="handleFocusOutEffectMenu"
    >
      <ul>
        <li>
          <span
            class="effect-item"
            :class="{'effect-item-disable' : (currentlyPlayingEffect.length > 0
              && currentlyPlayingEffect !== 'c')}"
            @click="handleEffectItemClicked('c')"
          >
            <span class="icon">
              <img src="@/assets/images/effects-menu/confetti-color.svg">
            </span>
            <span class="text">{{ $i18nPresenter.t('Confetti') }}</span>
            <span class="hot-key">C</span>
          </span>
        </li>
        <li>
          <span
            class="effect-item"
            :class="{'effect-item-disable' : (currentlyPlayingEffect.length > 0
              && currentlyPlayingEffect !== 'a')}"
            @click="handleEffectItemClicked('a')"
          >
            <span class="icon">
              <img src="@/assets/images/effects-menu/hand-clap.svg">
            </span>
            <span class="text">{{ $i18nPresenter.t('Applause') }}</span>
            <span class="hot-key">A</span>
          </span>
        </li>
        <li>
          <span
            class="effect-item"
            :class="{'effect-item-disable' : (currentlyPlayingEffect.length > 0
              && currentlyPlayingEffect !== 'd')}"
            @click="handleEffectItemClicked('d')"
          >
            <span class="icon">
              <img src="@/assets/images/effects-menu/drum-roll-color.svg">
            </span>
            <span class="text">{{ $i18nPresenter.t('Drumroll') }}</span>
            <span class="hot-key">D</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import QuizStatuses from '@/constant/QuizStatuses'
import EventBus from '@/eventBus'
import Util from '@/util'

export default {
  data() {
    return {
      showEffectMenu: false,
      currentlyPlayingEffect: '',
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    ...mapGetters(['isPresenting', 'isTextColourLight']),
    isLiveChatVisible() {
      return this.presentation.isEnableChat &&
      !this.presentation.audiencePacing &&
      !this.presentation.privateMode &&
        (this.isQuizSlide ||
        this.isLeaderboardScreen ||
        this.isQRCodeSlide) &&
        this.isPresenting &&
        !this.isSharingView
    },
    isSharingView() {
      return this.$store.state.sharePresentation
    },
    isLeaderboardScreen() {
      return this.slideActive.type === 'leaderboard'
    },
    isQRCodeSlide() {
      const { type } = this.slideActive
      return type === 'qrcode' && this.$store.state.presentation.slides.some((slide) => slide.type === 'pickAnswer')
    },
    isQuizSlide() {
      const { type, quizStatus } = this.slideActive
      return type === 'pickAnswer' && (
        quizStatus === QuizStatuses.LOBBY_SCREEN ||
        quizStatus === QuizStatuses.RESULT_SCREEN
      )
    },
    isTextColourWhite() {
      return this.isTextColourLight
    },
  },
  watch: {
    '$store.state.slideActive': function slideActiveChangeWatcher() {
      this.showEffectMenu = false
    },
    '$store.getters.isPresenting': function isPresentingWatcher(isPresenting) {
      if (!isPresenting) {
        this.showEffectMenu = false
      }
    },
  },
  mounted() {
    EventBus.$on('effect-wrapper-hided', () => {
      this.currentlyPlayingEffect = ''
    })
    EventBus.$on('effect-wrapper-showed', (key) => {
      this.currentlyPlayingEffect = key
    })
  },
  destroyed() {
    EventBus.$off('effect-wrapper-hided')
    EventBus.$off('effect-wrapper-showed')
  },
  methods: {
    setEffectMenuVisibility: debounce(function setEffectMenuVisibility(value) {
      this.showEffectMenu = value
    }, 150),
    handleEffectItemClicked(key) {
      this.currentlyPlayingEffect = key
      EventBus.$emit('effect-menu-clicked', key)
    },
    handleHoverEffectMenuToggleIcon() {
      this.showEffectMenu = true
      const { type, slideType } = this.slideActive
      const slideName = Util.getCorrectSlideTypeName(type, slideType)
      Util.mixpanelTracking('Presenting Mode', 'Nav > Effects legend > Hover', '', '', {
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        slideType: slideName,
      })
    },
    handleClickIcon() {
      if (!this.showEffectMenu) {
        this.showEffectMenu = false
      }
      const { type, slideType } = this.slideActive
      const slideName = Util.getCorrectSlideTypeName(type, slideType)
      Util.mixpanelTracking('Presenting Mode', 'Nav > Effects legend > Clicked', '', '', {
        presentationid: this.presentation.id,
        slideId: this.slideActive.id,
        slideType: slideName,
      })
    },
    handleFocusOutEffectMenu() {
      this.showEffectMenu = false
    },
  },
}
</script>
<style scoped lang='scss'>
.white-icon {
  filter: invert(1);
}
.effect-menu-toggle {
  position: relative;
  max-width: 2rem;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: none;
  }

  &:hover::before {
    display: inline;
    top: -30px;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
.ground-menu-toggle {
  left: 50%;
  height: 60px;
  position: absolute;
  bottom: 100%;
  cursor: default;
  --ground-menu-width: 14rem;
  width: var(--ground-menu-width);
  transform: translateX(-50%);
}
.effect-menu {
  --effect-menu-width: 14rem;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  width: var(--effect-menu-width);
  text-align: center;
  border-radius: 8px;
  font-family: 'Nunito';
  cursor: initial;
  bottom: 3.5rem;
  display: block;
  padding-bottom: 0px;
  left: 50%;
  transform: translateX(-50%);

  &.ppt-effect {
    transform: translateX(-30%);
  }

  &.white {
    background: rgba(24, 25, 27);
    .text {
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      color: #FFFFFF;
    }
    .hot-key {
      text-align: center;
      margin: 0.5rem;
      border-radius: 4px;
      background: rgb(82, 95, 127);
      font-size: 14px;
      font-weight: 700;
    }
  }
  &.black {
    background: rgba(255, 255, 255);
    box-shadow: 0 0 1px 1px #bbbec8;
    .text {
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      color: #191F2D;
    }
    .hot-key {
      @apply bg-secondary-20 text-secondary-100;
      text-align: center;
      margin: 0.5rem;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 700;
    }
  }
  ul {
    padding: 0.5rem;
    margin-bottom: 0;
    display: grid;
    list-style: none;
    li {
      display: flex;
      .icon {
        float: left;
        margin-bottom: auto;
      }
    }
  }
}

.effect-item-disable {
  cursor: initial;
  pointer-events: none;
  opacity: 0.2;
  &:hover {
    background: initial;
  }
}

.effect-item {
  cursor: pointer;
  display: grid;
  width: 100%;
  grid-template-columns: 17% 66% 17%;
  border-radius: 8px;
  align-items: center;
  &:hover {
    background: rgba(206,206,206, 0.2);
  }
}

.effect-header {
  display: grid;
  width: 100%;
  grid-template-columns: 17% 83%;
  padding: 0.5rem;
  &.white {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  &.black {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  grid-template-columns: 17% 83%;
  align-items: center;
  cursor: initial;
}

.effect-tooltip {
  position: absolute;
  display: inline-block;
  font-size: 12px!important;
  line-height: 18px;
  padding: 5px 10px 4px;
  background: #282E3E;
  color: #FFFFFF;
  border-radius: 4px;
  z-index: 300;
  bottom: 3.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
}
</style>
